import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EnvelopeGlyph = /*#__PURE__*/createElement("g", {
  id: "envelope"
}, /*#__PURE__*/createElement("path", {
  d: "M67.1,34.2L67.1,34.2l-6.8-5.5v-6.5h-8.2l-7.7-6.1c-1-0.8-2.5-0.8-3.5,0l-8.1,6.1h-9.2v6.9l-6.6,5 c-0.8,0.4-1.3,1.3-1.3,2.2v29.9c0,1.4,1.1,2.6,2.6,2.6h47.4c1.4,0,2.6-1.1,2.6-2.6V36.4C68.3,35.5,67.8,34.7,67.1,34.2z M61.9,33.8 l2.4,1.7l-1.9,1.3l-2.1,1.6v-5.8L61.9,33.8z M42.7,18.6l4.6,3.7h-9.5L42.7,18.6z M26.6,25.2h30.8v15.5l-0.1,0L41.7,52.5l-15-11.8 l-0.1,0V25.2z M22.5,33.8l1.2-0.9v5.4l-1.9-1.5l-1.6-1.3L22.5,33.8z M18.7,38.2l14.6,11.5l-14.6,14V38.2z M20.9,65.8l14.8-14.2 l4.2,3.3c0.5,0.4,1.1,0.6,1.8,0.6c0.6,0,1.2-0.2,1.7-0.5l4.5-3.4L63,65.8H20.9z M65.3,63.8L50.3,49.7l14.9-11.2V63.8z"
}));
const Envelope = createSvg({
  name: 'envelope',
  path: EnvelopeGlyph
});

export default Envelope;
export { EnvelopeGlyph };
